var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickDouble04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8966 7.13081C22.2168 8.02828 21.7678 8.64274 20.8986 9.248C20.1973 9.73636 19.3039 10.2654 18.3572 11.1699C17.4291 12.0566 16.5234 13.1246 15.7184 14.1758C14.743 15.4496 13.8206 16.7801 13.0087 18.1655C12.7026 18.6902 12.1521 19.0078 11.5619 18.9999C10.9716 18.9919 10.4293 18.6597 10.1364 18.1267C9.38765 16.764 8.80986 16.2259 8.5443 16.0326C7.8075 15.4963 7 15.4035 7 14.2335C7 13.2762 7.74623 12.5002 8.66675 12.5002C9.32548 12.5266 9.92854 12.8088 10.4559 13.1927C10.7981 13.4418 11.1605 13.7711 11.5375 14.2047C11.9799 13.551 12.5131 12.7968 13.1107 12.0163C13.9787 10.8829 15.0032 9.66689 16.1019 8.61719C17.1819 7.58531 18.4306 6.61941 19.7542 6.10872C20.6172 5.77573 21.5764 6.23333 21.8966 7.13081Z",
    stroke: "#F2FCF7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43961 12.5755C4.28117 12.5236 4.13796 12.4909 4.01252 12.4713C3.94995 12.4615 3.89226 12.455 3.83976 12.451L3.69887 12.4454C2.76061 12.4454 2 13.228 2 14.1933C2 15.0669 2.62294 15.7908 3.43675 15.9205C3.4652 15.9355 3.51137 15.9624 3.57407 16.0076C3.84474 16.2025 4.43367 16.7452 5.19686 18.1193C5.49542 18.6569 6.04811 18.9918 6.64983 18.9999C7.06202 19.0054 7.45518 18.8567 7.76226 18.5924M15 6C13.6509 6.515 12.3781 7.48904 11.2773 8.52963C10.8929 8.89299 10.5174 9.27611 10.1542 9.66884",
    stroke: "#F2FCF7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickDouble04);
export default __webpack_public_path__ + "static/media/tick-double-04.6cedbffe8a5d2cc4f55b5b6ca4827c8f.svg";
export { ForwardRef as ReactComponent };